// extracted by mini-css-extract-plugin
export default {"text":"Field_text__ls5Te","body":"Field_body__xDAxd"};